/* Sheets: spreadsheets with live server-side formulas, charts, pivots and AI columns (OFFICE-03),
   dashboards (OFFICE-06), forms and surveys (OFFICE-08) and co-editing for sheets (COLLAB-02).
   API: api/src/modules/sheets/README.md. */
import { lazy } from 'react';
import { Table2 } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'sheets',
  title: 'Sheets',
  short: 'Sheets',
  icon: Table2,
  group: 'Apps',
  route: '/sheets',
  order: 30,
  screen: lazy(() => import('./Screen.tsx')),
  commands: [
    { id: 'new', title: 'Sheets: open spreadsheets', to: '/sheets', keywords: ['spreadsheet', 'excel', 'xlsx', 'formula'] },
    { id: 'dashboards', title: 'Sheets: dashboards', to: '/sheets?tab=dashboards', keywords: ['kpi', 'charts', 'report'] },
    { id: 'forms', title: 'Sheets: forms and surveys', to: '/sheets?tab=forms', keywords: ['survey', 'quiz', 'registration', 'intake'] },
  ],
  capabilities: ['OFFICE-03', 'OFFICE-06', 'OFFICE-08', 'COLLAB-02'],
});
